import { useState } from "react";
import SignIn from "../components/Auth/SignIn";
import SignUp from "../components/Auth/SignUp";
import PageTitle from "../components/Common/PageTitle";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Auth = () => {
  const [isSignIn, setIsSignIn] = useState(true);
  return (
    <>
      <PageTitle value={"Sign In | SHWETFLIX"} />

      <video
        autoPlay
        muted
        loop
        id="myVideo"
        className="fixed -top-[135px] object-cover left-0 h-[135vh] w-full md:max-w-[40vw] lg:max-w-[60vw] -z-10"
      >
        <source src="https://cutt.ly/53o5dzS" type="video/mp4" />
      </video>

      <Link
        to="/"
        className="absolute top-0 left-0 flex justify-center items-center gap-3 mx-10 my-8 scale-125 invisible md:visible"
      >
        <LazyLoadImage
          alt="Logo"
          src="/logoicon.png"
          effect="opacity"
          className="w-12 h-12"
        />
        <div>
          <h1 className="text-xl text-white tracking-widest font-semibold uppercase">
            SHWETFLIX
          </h1>
          <h4 className="text-primary font-semibold">Its Show Time</h4>
        </div>
      </Link>
      <div className="bg-black/70 min-h-screen">
        {!isSignIn && <SignUp setIsSignIn={setIsSignIn} isSignIn={isSignIn} />}
        {isSignIn && <SignIn setIsSignIn={setIsSignIn} isSignIn={isSignIn} />}
      </div>
    </>
  );
};

export default Auth;
